import { render, staticRenderFns } from "./dev-header-routes.vue?vue&type=template&id=43d38c7d&"
import script from "./dev-header-routes.vue?vue&type=script&lang=js&"
export * from "./dev-header-routes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports